var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnanswered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sad-emoticon-square-face-with-closed-eyes-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.273,
    height: 20.273,
    viewBox: "0 0 20.273 20.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7184",
    "data-name": "Path 7184",
    d: "M11.276,7.916a1.7,1.7,0,0,1,3.4,0,.489.489,0,1,1-.978,0,.724.724,0,0,0-1.448,0,.489.489,0,0,1-.978,0Zm-5.42-.005a1.7,1.7,0,0,1,3.4,0,.489.489,0,0,1-.978,0,.724.724,0,0,0-1.448,0,.489.489,0,0,1-.978,0Zm-.021,6.341a4.807,4.807,0,0,1,4.509-2.875,4.84,4.84,0,0,1,4.482,2.86.586.586,0,1,1-1.076.466,3.669,3.669,0,0,0-3.406-2.153A3.638,3.638,0,0,0,6.918,14.7a.587.587,0,0,1-1.084-.45ZM16.71,20.273H3.564A3.568,3.568,0,0,1,0,16.71V3.564A3.568,3.568,0,0,1,3.564,0H16.709a3.568,3.568,0,0,1,3.564,3.564V16.709A3.568,3.568,0,0,1,16.71,20.273ZM3.564,1.677A1.889,1.889,0,0,0,1.677,3.564V16.709A1.889,1.889,0,0,0,3.564,18.6H16.709A1.889,1.889,0,0,0,18.6,16.709V3.564a1.889,1.889,0,0,0-1.887-1.887H3.564Z",
    fill: "#d58610"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnanswered);
export default __webpack_public_path__ + "static/media/unanswered.6e02e4b829a10a6c5b2cbb1772893b42.svg";
export { ForwardRef as ReactComponent };